var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{},[_c('v-flex',{staticClass:"d-block",domProps:{"innerHTML":_vm._s(_vm.question.questionTitle)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }